import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-list',
	templateUrl: './list.component.html',
	styleUrls: ['./list.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class ListComponent {
	@Input() listStyle: 'ordered' | 'unordered' = `unordered`;

	constructor() { }
}
